"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var attending_1 = require("../../model/attending");
var branch_service_1 = require("../../../shared/service/branch.service");
var equipment_1 = require("../../../shared/model/equipment");
var Subject_1 = require("rxjs/Subject");
var Observable_1 = require("rxjs/Observable");
var jira_ticket_service_1 = require("../../../appraisal/service/jira-ticket.service");
var screening_service_1 = require("../../service/screening.service");
var screening_1 = require("../../model/screening");
var provided_service_service_1 = require("../../../shared/service/provided-service.service");
var equipment_model_service_1 = require("../../../shared/service/equipment-model.service");
var auto_eletric_service_1 = require("../../../shared/service/auto-eletric.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var attending_service_1 = require("../../service/attending.service");
var attending_type_service_1 = require("../../../shared/service/attending-type.service");
var ScreeningComponent = /** @class */ (function () {
    function ScreeningComponent(_branchService, _jiraTicketService, _screeningService, _providedServiceService, _equipmentModelService, _autoEletricService, _attendingService, _toastService, _attendingTypeService) {
        this._branchService = _branchService;
        this._jiraTicketService = _jiraTicketService;
        this._screeningService = _screeningService;
        this._providedServiceService = _providedServiceService;
        this._equipmentModelService = _equipmentModelService;
        this._autoEletricService = _autoEletricService;
        this._attendingService = _attendingService;
        this._toastService = _toastService;
        this._attendingTypeService = _attendingTypeService;
        this.txOnSave = new core_1.EventEmitter();
        this.txOnCancel = new core_1.EventEmitter();
        this.branchAttributesTree = ['name'];
        this.equipmentModelAttributesTree = ['model'];
        this.osIsEditable = true;
        this.autoEletricsResultLimit = 3;
        this.autoEletricsNotFoundMessage = undefined;
        this.typedProvidedService = '';
        this.allowedTypesArray = ['Manutenção', 'Instalação'];
        this.setEmptyEntities();
        this.initAttending();
        this.setUpObservers();
        this.findProvidedServices();
        this.findEquipmentModels();
    }
    ScreeningComponent.prototype.ngOnInit = function () {
    };
    ScreeningComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    Object.defineProperty(ScreeningComponent.prototype, "attending", {
        get: function () {
            return this._attending;
        },
        set: function (attending) {
            this._attending = attending;
            this.initAttending();
        },
        enumerable: true,
        configurable: true
    });
    ScreeningComponent.prototype.findBranch = function (event) {
        this._branchService.findByName(event);
    };
    ScreeningComponent.prototype.save = function () {
        if (this.validateRequiredServices()) {
            this.attending.type = this.attendingType;
            if (this.autoEletricId != null) {
                var associateAutoEletric = { 'attendingInfoId': this.attending.attendingInfo.id, 'autoEletricId': this.autoEletricId,
                    'autoEletricStep': 'SCREENING', 'suggestedByArgos': true };
                this.attending.screening.associateAutoeletric = associateAutoEletric;
            }
            this.txOnSave.emit({
                attending: this.attending
            });
        }
        else {
            this.showMessage('Inclua no mínimo um serviço para este atendimento!');
        }
    };
    ScreeningComponent.prototype.cancel = function () {
        this.txOnCancel.emit();
    };
    ScreeningComponent.prototype.addProvidedService = function (service) {
        var serviceExist = this.attending.screening.providedServices.some(function (s) { return s.id === service.id; });
        if (!serviceExist) {
            this.attending.screening.providedServices.push(service);
        }
        this.typedProvidedService = '';
    };
    ScreeningComponent.prototype.removeProvidedService = function (event, index) {
        event.preventDefault();
        this.attending.screening.providedServices.splice(index, 1);
    };
    ScreeningComponent.prototype.changeBranch = function (branch) {
        this.attending.branch = branch;
    };
    ScreeningComponent.prototype.findArgosAutoEletrics = function () {
        var _this = this;
        if (this.canSearchForAutoEletrics()) {
            this._autoEletricService
                .findBests(this.getSearchParams())
                .subscribe(function (autoEletrics) { return _this.handleFindArgosAutoEletrics(autoEletrics); }, function (error) { return _this.handleEmptyFindArgosAutoEletrics(error); });
        }
    };
    ScreeningComponent.prototype.handleFindArgosAutoEletrics = function (autoEletrics) {
        this.argosAutoEletrics = autoEletrics;
        this.autoEletricsNotFoundMessage = undefined;
        if (this.argosAutoEletrics.length < 1) {
            this.autoEletricsNotFoundMessage = 'Nenhuma Auto elétrica encontrada para este(s) serviço(s) e Kit';
        }
        else {
            this.autoEletricsNotFoundMessage = null;
        }
    };
    ScreeningComponent.prototype.handleEmptyFindArgosAutoEletrics = function (error) {
        try {
            this.showMessage(error.json().text || error);
            this.argosAutoEletrics = error._body;
        }
        catch (e) {
            this.showMessage('Erro encontrado ao se recuperar as Auto Elétricas, entre em contato com o Administrador');
        }
    };
    ScreeningComponent.prototype.argosSelectsAutoEletric = function (autoEletric) {
        if (this.autoEletricId === autoEletric.id) {
            this.autoEletricId = null;
        }
        else {
            this.autoEletricId = autoEletric.id;
        }
    };
    ScreeningComponent.prototype.getObjectKeys = function (object) {
        if (object) {
            return Object.keys(object);
        }
        return [];
    };
    ScreeningComponent.prototype.canEdit = function () {
        return (this.attending.screening.canEdit || this.attending.screening.canEdit) === undefined && this.editable;
    };
    ScreeningComponent.prototype.canView = function () {
        return this.attending.screening.canView && !this.canEdit();
    };
    ScreeningComponent.prototype.canViewComponent = function (types) {
        return types.includes(this.attendingType);
    };
    ScreeningComponent.prototype.setEquipmentModel = function (model) {
        this.attending.screening.equipmentModel = model;
    };
    ScreeningComponent.prototype.canSearchForAutoEletrics = function () {
        return this.hasProvidedServices()
            && this.attending.branch
            && this.attending.screening.equipmentModel
            && this.canEdit();
    };
    ScreeningComponent.prototype.resolveJiraTicketResult = function (jiraTicket) {
        this.attending.vehiclePlate = jiraTicket.vehiclePlate || this.attending.vehiclePlate;
        this.attending.attendingEquipmentInfo.ticketEquipment =
            jiraTicket.equipment ||
                this.attending.attendingEquipmentInfo.ticketEquipment;
    };
    ScreeningComponent.prototype.hasProvidedServices = function () {
        return this.attending.screening &&
            this.attending.screening.providedServices &&
            this.attending.screening.providedServices.length > 0;
    };
    ScreeningComponent.prototype.getSearchParams = function () {
        return {
            providedServices: this.attending.screening.providedServices,
            branchId: this.attending.branch ? this.attending.branch.id : null,
            equipmentModelId: this.attending.screening.equipmentModel ? this.attending.screening.equipmentModel.id : null,
            resultLimit: this.autoEletricsResultLimit
        };
    };
    ScreeningComponent.prototype.validateRequiredServices = function () {
        return this.attending.screening.providedServices.length > 0;
    };
    ScreeningComponent.prototype.setUpObservers = function () {
        var _this = this;
        this._jiraTicketService.find$
            .subscribe(function (jiraTicket) { return _this.resolveJiraTicketResult(jiraTicket); });
        this.setUpTicketInputObserver();
        this._branchService.find$
            .filter(function (branches) { return branches instanceof Array; })
            .subscribe(function (branches) { return _this.branches = branches; });
        this._equipmentModelService.find$
            .subscribe(function (equipmentModels) { return _this.equipmentModels = equipmentModels; });
    };
    ScreeningComponent.prototype.setUpTicketInputObserver = function () {
        var _this = this;
        this.ticketInput
            .map(function (event) { return event.target.value; })
            .debounceTime(500)
            .distinctUntilChanged()
            .flatMap(function (search) { return Observable_1.Observable.of(search).delay(500); })
            .subscribe(function (typedValue) {
            if (typedValue && typedValue !== '' && _this.canEdit()) {
                _this.attending.vehiclePlate = null;
                _this.attending.equipment = null;
                _this.attending.serviceOrder = null;
                _this.osIsEditable = true;
                _this._jiraTicketService.findJiraTicket(typedValue);
            }
        });
    };
    ScreeningComponent.prototype.setEmptyEntities = function () {
        this.equipmentModels = [];
        this.ticketInput = new Subject_1.Subject();
        this.attending = new attending_1.Attending();
        this.attendingType = this._attendingTypeService.attendingType;
    };
    ScreeningComponent.prototype.initAttending = function () {
        this.attending.screening = this.attending.screening || new screening_1.Screening();
        this.attending.screening.providedServices = this.attending.screening.providedServices || [];
        this.attending.equipment = this.attending.equipment || new equipment_1.Equipment();
        this.attending.attendingEquipmentInfo = this.attending.attendingEquipmentInfo || {};
    };
    ScreeningComponent.prototype.findEquipmentModels = function () {
        this._equipmentModelService.findAll();
    };
    ScreeningComponent.prototype.findProvidedServices = function () {
        var _this = this;
        this._providedServiceService.findAll()
            .subscribe(function (providedServices) { return _this.providedServices = providedServices.sort(function (a, b) { return a.name > b.name ? 1 : -1; }); }, function (error) { return _this.showMessage(error); });
    };
    ScreeningComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    ScreeningComponent.ctorParameters = function () { return [{ type: branch_service_1.BranchService }, { type: jira_ticket_service_1.JiraTicketService }, { type: screening_service_1.ScreeningService }, { type: provided_service_service_1.ProvidedServiceService }, { type: equipment_model_service_1.EquipmentModelService }, { type: auto_eletric_service_1.AutoEletricService }, { type: attending_service_1.AttendingService }, { type: toast_service_1.ToastService }, { type: attending_type_service_1.AttendingTypeService }]; };
    return ScreeningComponent;
}());
exports.ScreeningComponent = ScreeningComponent;
//# sourceMappingURL=screening.component.js.map


// WEBPACK FOOTER //
// screening.component.js